/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import login from '@/components/login'
import openlistsDev from '@/components/openlistsDev'
import ClosedLists from '@/components/ClosedLists'
import NotFound from '@/components/NotFound'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/',
      name: 'OpenLists',
      component: openlistsDev,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/closedlists',
      name: 'ClosedLists',
      component: ClosedLists,
      beforeEnter: ifAuthenticated
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js